'use client';

import ErrorFallbackView from '@/components/shared/fallback/ErrorFallbackView';
import { AxiosError } from 'axios';
import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';

export default function GlobalError({
  error,
  reset,
  customMsg,
}: {
  error: AxiosError;
  reset: () => void;
  customMsg?: string;
}) {
  console.log('Global error component rendered', error, reset);
  const [msg, setMsg] = useState<string>('요청에 실패하였습니다. 다시 시도해주세요');
  useEffect(() => {
    if (error.response?.status === 403) {
      setMsg('접근 권한이 없는 페이지입니다');
    }
    // 에러 로깅
    console.error('Global error:', error);
  }, [error]);

  return (
    <html>
      <body>
        <ErrorFallbackView msg={customMsg ? customMsg : msg} />
      </body>
    </html>
  );
}
